var infoc = Infoc.b('qdjl');

/**
 * 专题上报
 */
export default class Report {
	showToReport(reportInitData = {}) {
		console.log('init...');
		infoc.report(reportInitData);
	}

	clickToReport(reportData) {
		console.log('click...');
		infoc.report(reportData);
	}
}
